<template>
    <li @click="searchOnThis" class="ui-menu-item autocompleteItem" v-bind:class="{ active: isActive }" role="presentation"  >
        <span class="ui-corner-all" tabindex="-1" v-html="formatResult"></span>
    </li>
</template>

<script>
  export default {
    props: ['index','title','selectedItem','searchValue'],
    computed:{
      cleanSearchValue() {
        return this.searchValue.replace(/[\u2018\u2019]/g, '\''); //undo iOS "Smart Punctuation"
      },
      formatResult() {
        let startHighlight = this.title.toLowerCase().indexOf(this.cleanSearchValue.toLowerCase());
        let endHighlight = startHighlight + this.cleanSearchValue.length;
        if(startHighlight < 0) {
          return this.title;
        } else {
          return this.title.slice(0, startHighlight) + '<b class="result-highlight">' + this.title.slice(startHighlight,endHighlight) + '</b>' + this.title.slice(endHighlight);
        }

      },
      isActive(){
        if(this.index === this.selectedItem){
          return true;
        }
        return false;
      }
    },
    methods: {
      searchOnThis(){
        this.$emit('searchOnThis', this);
      },
    },
    created(){
      if(this.index === this.selectedItem){
        this.$emit('active-title',this);
      }
    }
  };
</script>

<style scoped>
    .autocompleteItem {
        border:1px solid transparent;
        color: #5d676f;
      user-select: none;
    }

</style>
